<template>
	<div
		v-editable="blok"
		class="gap-6 mb-2 md:mb-4"
		:class="[
			blok.variants === 'large' && 'md:columns-2',
			blok.variants === 'regular' && 'md:columns-2 lg:columns-3',
			blok.variants === 'small' && 'sm:columns-2 lg:columns-4',
		]"
	>
		<div v-for="item in blok.children" :key="item._uid" class="break-inside-avoid-column pb-6">
			<StoryblokComponent :blok="item" />
		</div>
	</div>
</template>

<script setup lang="ts">
	import type {TilesListStoryblok} from '@/storyblok/types';

	interface Props {
		blok: TilesListStoryblok
	}

	defineProps<Props>();
</script>
